import React from 'react';
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from 'recharts';
import { PERFORMANCE_DATA } from '../constants';

const tooltipStyle = { 
  backgroundColor: '#050505', 
  borderColor: '#1e293b', 
  color: '#e2e8f0',
  borderRadius: '0px',
  borderWidth: '1px',
  fontFamily: 'JetBrains Mono',
  fontSize: '12px',
  padding: '12px'
};

const itemStyle = { color: '#8CAB91' };
const cursorStyle = { stroke: '#334155', strokeWidth: 1 };

const StatsChart: React.FC = () => {
  return (
    <div className="w-full h-[450px] bg-slate-950 border border-slate-900 p-0 relative">
      <div className="absolute top-0 left-0 px-6 py-3 border-r border-b border-slate-900 bg-slate-950 z-10">
        <h3 className="text-xs font-mono text-sage-400 tracking-widest uppercase">Unit Growth Chart</h3>
      </div>
      
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart
          data={PERFORMANCE_DATA}
          margin={{
            top: 60,
            right: 0,
            left: 0,
            bottom: 0,
          }}
        >
          <defs>
            <linearGradient id="colorProfit" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#8CAB91" stopOpacity={0.15}/>
              <stop offset="95%" stopColor="#8CAB91" stopOpacity={0}/>
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="0 0" stroke="#111318" vertical={true} horizontal={true} />
          <XAxis 
            dataKey="month" 
            stroke="#334155" 
            tick={{fontSize: 10, fontFamily: 'JetBrains Mono', fill: '#475569'}} 
            axisLine={false}
            tickLine={false}
            dy={10}
          />
          <YAxis 
            stroke="#334155" 
            tick={{fontSize: 10, fontFamily: 'JetBrains Mono', fill: '#475569'}} 
            axisLine={false}
            tickLine={false}
            tickFormatter={(value) => `${value}u`}
            dx={-10}
            orientation="right"
          />
          <Tooltip 
            contentStyle={tooltipStyle}
            itemStyle={itemStyle}
            cursor={cursorStyle}
            formatter={(value: number) => [`+${value} Unidades`, 'Beneficio']}
          />
          <Area 
            type="monotone" 
            dataKey="profit" 
            stroke="#8CAB91" 
            strokeWidth={1.5}
            fillOpacity={1} 
            fill="url(#colorProfit)" 
            activeDot={{ r: 4, fill: '#8CAB91', strokeWidth: 0 }}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default StatsChart;